'use client';

import classnames from 'classnames';
import { Button } from '@stadionhq-v3/base-ui';
import { ItemData } from '@core/types/cloudmatrix.types';
import { BasicComponentProps } from '@stadionhq-v3/core';
import { ArrowRight } from '@components/icons';
import { signIn } from 'next-auth/react';
import styles from './vodOverlay.module.scss';

export type VodOverlayProps = BasicComponentProps & {
  videoData?: ItemData;
  dictionary: {
    title: string;
    subTitle: string;
    subscribeCtaLabel: string;
    purchaseCtaLabel: string;
  };
  purchaseLink?: {
    url: string;
  };
  showSignInCta?: boolean;
};

const VodOverlay = ({
  classNames,
  testId,
  videoData,
  dictionary,
  purchaseLink,
  showSignInCta = false,
}: VodOverlayProps) => {
  const classes = classnames([styles.container], classNames);

  return (
    <section
      className={classes}
      data-component="CloudMatrixLocked"
      data-testid={testId}
    >
      <div className={classnames(styles.overlay)}>
        <img
          className={classnames(styles.overlayThumbnail)}
          src={`${videoData?.mediaData.thumbnailUrl}?width=0`}
          alt={videoData?.metaData.title}
        />
        <div className={classnames(styles.overlayMembersOnly)}>
          <h3 className={classnames(styles.overlayTitle)}>
            {dictionary.title}
          </h3>
          <span className={classnames(styles.overlaySubtitle)}>
            {dictionary.subTitle}
          </span>
          <div className={classnames(styles.overlayCtas)}>
            {purchaseLink && (
              <Button
                variant="primary"
                text={dictionary.purchaseCtaLabel}
                iconAfter={<ArrowRight />}
                url={purchaseLink.url}
                target="_self"
              />
            )}
            {showSignInCta && (
              <Button
                variant="primary"
                text={dictionary.subscribeCtaLabel}
                iconAfter={<ArrowRight />}
                onClick={(e) => {
                  e?.preventDefault();
                  signIn('default', { callbackUrl: window.location.href });
                }}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VodOverlay;
